module.exports = __webpack_public_path__ + "img/clue2_light.d27b7f9b.png";